import { render, staticRenderFns } from "./Dba.vue?vue&type=template&id=2353abef&"
import script from "./Dba.vue?vue&type=script&lang=js&"
export * from "./Dba.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports